/* eslint-disable max-len */
const accountTransaction = require('./account-transaction.json');

/**
 * @typedef {Object} AccountTransaction
 * No additional properties allowed.
 * @property {string} FEE_AMT
 * @property {string} GLCODE
 * @property {string} NARR
 * @property {string} [NARR1] - Optional, max length is 50 characters.
 * @property {string} TCODE
 * @property {string} EFF_DATE - Must be a valid date format.
 * @property {number} XREF
 * @property {string} OPTION
 */

/**
 * Sale related validation schemas for collateral
 * @module schemas/accountTransaction
 * @property {AccountTransaction} accountTransaction
 */
module.exports = {
  accountTransaction,
};
